
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'


export default {
props: {
matchInfo: Object
},
components: {
Flexbox,
FlexboxItem
},
mounted(){
this.reload();
},
methods: {
toMatchLive() {
this.$router.push({
path: '/match_info', query: {
matchId: this.matchInfo.id,
homeTeamId: this.matchInfo.homeTeamId,
visitTeamId: this.matchInfo.vistingTeamId,
currentTab: 'matchLiveTab'
}
});
},
viewMatch(){
this.$router.push({
path: '/match_info', query: {
matchId: this.matchInfo.id,
homeTeamId: this.matchInfo.homeTeamId,
visitTeamId: this.matchInfo.vistingTeamId,
currentTab: 'matchScoresTab'
}
});
},
reload(){
this.objInfo = this.matchInfo;
this.score = this.genScore();
},
genScore() {
var score = '';
if (this.objInfo && this.objInfo.result) {
var matchObj = this.objInfo.result;
var defaultPkScore = (matchObj.homePkScore || matchObj.visitorPkScore) ? "(0)" : "";



score += matchObj.goalFor + matchObj.homeExScore + (matchObj.homePkScore ? matchObj.homePkScore : 0);
score += "-";
score += matchObj.goalAgainst + matchObj.visitorExScore + (matchObj.visitorPkScore ? matchObj.visitorPkScore : 0);
} else {

score = "VS"
}
return score
}
},
data () {
return {
score: "",
objInfo: {},
}
},
watch: {
matchInfo(curVal, oldVal){
this.reload();
}
}
}



// WEBPACK FOOTER //
// ./src/components/league/matchSimple.vue